(() => {
  console.log('[Cart Footer] Toggle script loaded');

  /*
   * Available states:
   *
   * half       = default 50% viewport height
   * expanded   = nearly full viewport
   * collapsed  = title bar only
   */
  window.cartFooterState =
    window.cartFooterState || 'half';


  function applyCartFooterState() {
    document
      .querySelectorAll('[data-cart-shared-footer]')
      .forEach((footer) => {
        const toggle = footer.querySelector(
          '[data-cart-footer-toggle]'
        );

        const state = window.cartFooterState;

        footer.classList.toggle(
          'is-expanded',
          state === 'expanded'
        );

        footer.classList.toggle(
          'is-collapsed',
          state === 'collapsed'
        );

        if (toggle) {
          toggle.setAttribute(
            'aria-expanded',
            state === 'collapsed'
              ? 'false'
              : 'true'
          );
        }
      });
  }


  if (!window.cartFooterToggleInitialized) {
    window.cartFooterToggleInitialized = true;


    document.addEventListener('click', (event) => {

      /*
       * X button:
       * close completely to title bar.
       */
      const closeButton = event.target.closest(
        '[data-cart-footer-close]'
      );

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();

        window.cartFooterState = 'collapsed';

        console.log(
          '[Cart Footer] State:',
          window.cartFooterState
        );

        applyCartFooterState();

        return;
      }


      /*
       * Main title / caret button.
       */
      const toggle = event.target.closest(
        '[data-cart-footer-toggle]'
      );

      if (!toggle) return;

      event.preventDefault();


      /*
       * Collapsed -> restore 50%
       *
       * Half -> expand
       *
       * Expanded -> return to 50%
       */
      if (window.cartFooterState === 'collapsed') {
        window.cartFooterState = 'half';

      } else if (window.cartFooterState === 'half') {
        window.cartFooterState = 'expanded';

      } else {
        window.cartFooterState = 'half';
      }


      console.log(
        '[Cart Footer] State:',
        window.cartFooterState
      );

      applyCartFooterState();
    });
  }


  const cartDrawer =
    document.getElementById('cart-drawer');


  if (cartDrawer) {

    /*
     * Keep state working after Shopify / app rerenders.
     */
    if (
      cartDrawer.dataset.footerObserverInitialized !== 'true'
    ) {
      cartDrawer.dataset.footerObserverInitialized = 'true';

      let scheduled = false;

      const contentObserver = new MutationObserver(() => {
        if (scheduled) return;

        scheduled = true;

        requestAnimationFrame(() => {
          scheduled = false;
          applyCartFooterState();
        });
      });

      contentObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
      });


      /*
       * Every fresh drawer opening begins at 50%.
       */
      let drawerWasOpen =
        cartDrawer.hasAttribute('open') &&
        !cartDrawer.hasAttribute('hidden');

      const drawerStateObserver =
        new MutationObserver(() => {
          const drawerIsOpen =
            cartDrawer.hasAttribute('open') &&
            !cartDrawer.hasAttribute('hidden');

          if (drawerIsOpen && !drawerWasOpen) {
            window.cartFooterState = 'half';

            requestAnimationFrame(
              applyCartFooterState
            );
          }

          drawerWasOpen = drawerIsOpen;
        });

      drawerStateObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['open', 'hidden']
      });
    }
  }


  applyCartFooterState();
})();